import { useRef } from "react";
import type { FocusEvent, MouseEvent } from "react";

/**
 * Duration inputs replace their whole value when entered: people retype a time,
 * they rarely append digits to it. Mouse-up after focus would otherwise collapse
 * the selection into a caret, so the first mouse-up is ignored.
 */
export function useSelectAllOnFocus() {
  const justFocused = useRef(false);
  return {
    onFocus: (e: FocusEvent<HTMLInputElement>) => { justFocused.current = true; e.currentTarget.select(); },
    onMouseUp: (e: MouseEvent<HTMLInputElement>) => { if (justFocused.current) { e.preventDefault(); justFocused.current = false; } },
    onBlur: () => { justFocused.current = false; },
  };
}
